<div [formGroup]="fieldUpdateForm">
    <span>{{fieldUpdateConfig.name.displayName}}</span>
    <lib-cdw-select formControlName="fieldUpdateType" [values]="fieldUpdateConfig.updateTypes"></lib-cdw-select>
    <div *ngIf="showInputTemplate()" [ngSwitch]="fieldUpdateConfig.template">
        <div *ngSwitchCase="'select'">
            <lib-cdw-select [values]="fieldUpdateConfig.selectOptions ? fieldUpdateConfig.selectOptions : []" formControlName="fieldUpdateValue"></lib-cdw-select>
        </div>

        <div *ngSwitchCase="'autocomplete'">
            <lib-cdw-autocomplete [values]="fieldUpdateConfig.selectOptions ? fieldUpdateConfig.selectOptions : []" formControlName="fieldUpdateValue"></lib-cdw-autocomplete>
        </div>

        <div *ngSwitchCase="'checkbox'">
            <lib-cdw-autocomplete [values]="fieldUpdateConfig.selectOptions ? fieldUpdateConfig.selectOptions : []" formControlName="fieldUpdateValue"></lib-cdw-autocomplete>
        </div>

        <div class="tree-picker" *ngSwitchCase="'tree'">
            <lib-cdw-filtered-tree-picker formControlName="fieldUpdateValue" height="250px" [dataSource]="fieldUpdateConfig.selectOptions ? fieldUpdateConfig.selectOptions : []"></lib-cdw-filtered-tree-picker>
        </div>

        <div *ngSwitchDefault class="text-input-container">
            <mat-form-field appearance="fill" class="full-width" [class.validation-error]="hasValidationError" subscriptSizing="fixed">
                <mat-label>{{ fieldUpdateConfig.name.displayName }}</mat-label>
                <textarea
                    matInput
                    formControlName="fieldUpdateValue"
                    [errorStateMatcher]="immediateErrorMatcher"
                    [attr.aria-describedby]="ariaDescribedByIds"
                    [attr.aria-invalid]="hasValidationError"
                    rows="2"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="2"
                    cdkAutosizeMaxRows="5">
                </textarea>
            </mat-form-field>
            <!-- Character counter always visible (addresses Brian's review: counter should show with errors) -->
            <div *ngIf="showCharacterCounter" class="character-counter" [class.error]="isLimitExceeded">
                <span *ngIf="!hasLimitExceededError">{{ getCharacterCounterLabel() }}</span>
                <span *ngIf="hasLimitExceededError"
                      [id]="'bulk-field-limit-' + fieldUpdateConfig.name.value"
                      role="alert"
                      aria-live="polite">{{ limitExceededMessage }}</span>
                <span class="spacer"></span>
                <span>{{ currentInputLength }}/{{ maxAllowedLength }}</span>
            </div>
            <!-- Error messages with accessibility support (excludes limit exceeded, shown in counter row above) -->
            <div *ngIf="hasNonLimitErrors"
                 [id]="'bulk-field-errors-' + fieldUpdateConfig.name.value"
                 class="error-container"
                 role="alert"
                 aria-live="polite">
                <div class="error-list">
                    <div *ngFor="let errorMsg of nonLimitErrorMessages">{{ errorMsg }}</div>
                </div>
            </div>
        </div>
    </div>
</div>
